import { render, staticRenderFns } from "./NotificationTabs.vue?vue&type=template&id=23c07a58&scoped=true"
import script from "./NotificationTabs.vue?vue&type=script&lang=js"
export * from "./NotificationTabs.vue?vue&type=script&lang=js"
import style0 from "./NotificationTabs.vue?vue&type=style&index=0&id=23c07a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c07a58",
  null
  
)

export default component.exports